import {Injectable} from '@angular/core';
import {AuthHttpService} from "./auth-http.service";
import {CalculationRequest, CalculationResponse} from "../model/calculation/trial-lens.model";
import {Observable} from "rxjs";
import {optimistic} from "./common-http.service";

@Injectable({
  providedIn: 'root'
})
export class CalculationApiService {

  constructor(
    private authHttp: AuthHttpService
  ) { }

  calculateLens(request: Array<CalculationRequest>): Observable<CalculationResponse[]> {
    return this.authHttp.post<CalculationResponse[]>("/calculate", request).pipe(optimistic);
  }
}
